import React from 'react';
import {Helmet} from "react-helmet-async";
import {Link, useLocation} from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <>
            <Helmet>
                <title>Помилка 404 — Hlushman House</title>
                <meta name="title" content="Помилка 404" />
                <meta name="description" content="Здається, ви заблукали в горах." />
                <meta property="og:title" content="Помилка 404 — Сторінку, яку ви шукаєте, не знайдено або її було переміщено. Поверніться на головну, щоб продовжити планувати свій відпочинок." />
                <meta property="og:description" content="Ой! Сторінку не знайдено. Можливо, вона була переміщена або ви ввели невірну адресу. Поверніться на головну." />
                <meta property="og:image" content="https://hlushman.site/img/logo.jpg" />
                <meta property="og:url" content="https:///hlushman.site/404" />
            </Helmet>

            <div className="bg-stone-900 text-white min-h-screen flex items-center justify-center px-6 font-sans relative overflow-hidden">

                {/* Background Decorative Element */}
                <div
                    className="absolute inset-0 opacity-20 bg-cover bg-center pointer-events-none"
                    style={{ backgroundImage: "url('https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&q=80')" }}
                ></div>

                <div className="relative z-10 max-w-lg text-center">

                    {/* Visual Badge */}
                    <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-stone-800 border border-stone-700 text-4xl mb-6 shadow-inner">
                        🌲
                    </div>

                    {/* 404 Error Code */}
                    <span className="block text-emerald-400 font-semibold tracking-widest uppercase text-sm mb-2">
          Помилка 404
        </span>

                    {/* Heading */}
                    <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-stone-100">
                        Здається, ви заблукали в горах
                    </h1>

                    {/* Description */}
                    <p className="text-stone-400 text-base md:text-lg mb-8 leading-relaxed font-light">
                        Сторінку, яку ви шукаєте, не знайдено або її було переміщено. Поверніться на головну, щоб продовжити планувати свій відпочинок.
                    </p>

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <Link
                            to="/"
                            className="bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-3 px-8 rounded-full transition duration-300 shadow-lg text-center"
                        >
                            На головну
                        </Link>
                        <Link
                            to="/contacts"
                            className="border border-stone-700 hover:bg-stone-800 text-stone-300 hover:text-white font-medium py-3 px-8 rounded-full transition duration-300 text-center"
                        >
                            Наші контакти
                        </Link>
                    </div>

                </div>
            </div>
        </>
    );
};

export default NotFoundPage;